import { tv } from "../../variants/tv.js";
const disclaimerVariants = tv({
    slots: {
        paragraph: 'overflow-scroll text-pretty break-words leading-normal'
    }
});
export { disclaimerVariants };
